import React, { useContext, useMemo } from 'react';
import { SelectField } from 'components/ui_library/Formik';
import { helpText, selectStyle } from 'modules/Models/components/ModelForm/styles';
import { FormLabel } from './FormLabel';

export interface SelectOptions {
  id: string;
  content?: JSX.Element;
}

type EnhancedField = {
  config: {
    tooltip?: string;
    help?: string;
  };
};

interface SelectFormElementProps {
  description: string;
  path: string;
  placeholder: string;
  selectOptions: SelectOptions[];
  value: string;
  onChange: (v: { name: string | JSX.Element; value: string }) => void;
}

export const SelectFormElement = (props: SelectFormElementProps): JSX.Element | null => {
  const { description, path, placeholder, selectOptions: options, value, onChange } = props;
  const defaultContext = React.createContext<EnhancedField>({ config: {} });
  const { config } = useContext(defaultContext);

  const formattedOptions = useMemo(
    () =>
      options.map(({ id, content }) => {
        return { name: id, value: id, content };
      }),
    [options],
  );

  return (
    <>
      <FormLabel path={path} description={description} />
      <div className={selectStyle}>
        <SelectField name={path} value={value} placeholder={placeholder} options={formattedOptions} onChange={onChange} title={value} />
        {config?.help && <div className={helpText}>{config.help}</div>}
      </div>
    </>
  );
};
